import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Footer as ToolkitFooter, A } from '@contently/toolkit';
import setDatetimeObserver from '../../utils/datetimeObserver';

const Footer = ({ appData }) => {
  const { userSignedIn } = JSON.parse(appData);

  setDatetimeObserver();

  const config = {
    copyright: 'Contently',
    listItems: [
      () => (
        <A href="/terms" title="Terms of Service">
          Terms of Service
        </A>
      ),
      () => (
        <A href="/privacy-policy" title="Privacy Policy">
          Privacy Policy
        </A>
      ),
      () =>
        userSignedIn ? (
          <A href="https://help.contently.com/" title="Help">
            Help
          </A>
        ) : (
          <Fragment />
        )
    ]
  };
  return <ToolkitFooter config={config} />;
};

Footer.propTypes = {
  appData: PropTypes.string.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./app/javascript/app/components/layout/Footer.jsx